<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="col-12 shadow-btm row">
          <div class="col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-white">Manage Admins Users</h4>
          </div>

          <div class="col-6 text-right" v-show="accessObject?.is_add == 1">
            <a
              style="padding-left: 20px; padding-right: 20px; cursor: pointer"
              v-on:click="$router.push('/add-admin')"
              class="add-btn"
              >Add</a
            >
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="row">
              <div class="col-lg-6 col-sm-6 form-group row">
                <div class="has-search ml-3">
                  <i
                    class="fa fa-search"
                    style="position: absolute; margin: 10px"
                    aria-hidden="true"
                  ></i>
                  <input
                    type="text"
                    class="form-control"
                    v-on:keyup.enter="getList(0)"
                    placeholder="Search"
                    v-model="searchObj.keyword"
                  />
                </div>
                <a
                  class="search-btn btn-style cursor-pointer ml-3"
                  v-on:click="getList(0)"
                  >Search</a
                >
                <a
                  class="search-btn btn-style cursor-pointer"
                  v-on:click="resetFilter"
                  >Reset</a
                >
              </div>
            </div>
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <div class="dataTables_wrapper dt-bootstrap4">
                    <table
                      class="table table-striped table-bordered dataTable"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="example_info"
                    >
                      <colgroup>
                        <col style="width: 10%" />
                        <col style="width: 20%" />
                        <col style="width: 20%" />
                        <col style="width: 20%" />
                        <col style="width: 10%" />
                        <col
                          :style="
                            accessObject?.is_edit == 1 ||
                            accessObject?.is_delete == 1
                              ? 'width: 20%'
                              : ''
                          "
                        />
                      </colgroup>
                      <thead>
                        <tr role="row">
                          <th
                            class="sorting"
                            id="id-ids"
                            v-on:click="sorting('id', 'id-id')"
                          >
                            Sr No
                          </th>
                          <th
                            class="sorting"
                            id="id-name"
                            v-on:click="sorting('admin_name', 'id-name')"
                          >
                            Admin Name
                          </th>
                          <th
                            class="sorting"
                            id="id-email"
                            v-on:click="sorting('admin_email', 'id-email')"
                          >
                            Admin Email
                          </th>
                          <th
                            class="sorting"
                            id="id-contact"
                            v-on:click="sorting('admin_contact', 'id-contact')"
                          >
                            Contact Number
                          </th>
                          <th
                            class="sorting"
                            id="id-admin_type"
                            v-on:click="sorting('admin_type', 'id-admin_type')"
                          >
                            Admin Type
                          </th>
                          <th
                            class="sorting"
                            id="id-status"
                            v-on:click="sorting('is_active', 'id-status')"
                          >
                            Status
                          </th>
                          <th
                            v-if="
                              accessObject?.is_edit == 1 ||
                              accessObject?.is_delete == 1
                            "
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody v-show="!loader">
                        <tr v-for="(data, index) in list" :key="index">
                          <td>
                            {{
                              ($refs.listPagination.currentPage - 1) * $refs.listPagination.itemsPerPage +
                              index +
                              1
                            }}
                          </td>
                          <td>{{ data.admin_name }}</td>
                          <td>{{ data.admin_email }}</td>
                          <td>{{ data.admin_contact }}</td>
                          <td>{{ getType(data.admin_type) }}</td>
                          <td>
                            <a v-show="data.is_active == 'Y'" class="fill-btn"
                              >ACTIVE</a
                            >
                            <a
                              v-show="data.is_active == 'N'"
                              class="reject-btn btn-style"
                              >INACTIVE</a
                            >
                          </td>

                          <td
                            v-if="
                              accessObject?.is_edit == 1 ||
                              accessObject?.is_delete == 1
                            "
                          >
                            <a
                              v-if="accessObject?.is_edit == 1"
                              class="edit-btn btn-style cursor-pointer"
                              v-on:click="
                                $router.push('/edit-admin/' + data.id)
                              "
                              >Edit</a
                            >

                            <a
                              v-if="accessObject?.is_delete == 1"
                              class="delete-btn btn-style cursor-pointer"
                              v-on:click="showDeletePopup(data)"
                              >Delete</a
                            >
                            <a
                              v-if="
                                data.is_active == 'Y' &&
                                accessObject?.is_edit == 1
                              "
                              :id="'active-btn_' + data.id"
                              class="fill-btn cursor-pointer"
                              v-on:click="
                                updateStatus(
                                  data.id,
                                  'N',
                                  'active-btn_' + data.id
                                )
                              "
                              >ACTIVE</a
                            >
                            <a
                              v-if="
                                data.is_active == 'N' &&
                                accessObject?.is_edit == 1
                              "
                              :id="'inactive-btn_' + data.id"
                              class="reject-btn btn-style cursor-pointer"
                              v-on:click="
                                updateStatus(
                                  data.id,
                                  'Y',
                                  'inactive-btn_' + data.id
                                )
                              "
                              >INACTIVE</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-center">
                    <div class="page-bottom-pagination text-right">
                      <Pagination
                        @page-change="pageChange"
                        @items-per-page-change="itemsPerPageChange"
                        ref="listPagination"
                      />
                    </div>
                  </div>
                </div>
                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal
      @remove="deleteRecord($event)"
      @get-list="getList(0)"
      ref="deleteItem"
    />
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";

export default {
  name: "Admin",
  components: {
    ErrorComponent,
    DeleteModal,
    Pagination,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Manage Admins"),
      loader: true,
      searchObj: {},
      offset: -1,
      list: [],
    };
  },
  mounted() {
    this.getList(0);
  },
  methods: {
    getType(type) {
      if (type == "owner") {
        return "Owner";
      } else if (type == "admin") {
        return "Admin";
      } else if (type == "quality_analyst") {
        return "Quality Analyst";
      } else if (type == "data_entry_analyst") {
        return "Analyst";
      }
    },
    updateStatus(id, status, button_id) {
      var obj = {};
      obj.id = id;
      obj.is_active = status;
      this.$api
        .putAPI({
          _action: "/admin",
          _body: obj,
          _buttonId: button_id,
        })
        .then(() => {
          this.getList(0);
        })
        .catch(() => {});
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/admin/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.accessObject =
            this.$helperService.getAccessLevel("Manage Admins");
          this.list = res.list;
          this.offset = res.next_offset;

          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No admin list available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.getList(0);
    },
    showDeletePopup(data) {
      this.$refs.deleteItem.showModal(
        "Delete Admin",
        "Are you sure you want to delete " + data.admin_name,
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$refs.deleteItem.deleteRecord("/admin/" + detail.id);
    },
  },
};
</script>
